import { render, staticRenderFns } from "./TabsCard.vue?vue&type=template&id=314188ad&"
import script from "./TabsCard.vue?vue&type=script&lang=js&"
export * from "./TabsCard.vue?vue&type=script&lang=js&"
import style0 from "./TabsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports